<template>
    <div class="rr-builder-dialog" uk-modal>
        <div class="rr-builder-dialog__dialog uk-modal-dialog">
            <div class="rr-builder-dialog__header uk-modal-header">
                <h2 class="rr-builder-dialog__title uk-modal-title">{{ $t('rubinred.content.builder.closeModal.title', primaryLocale) }}</h2>
            </div>
            <div class="uk-modal-body">
                {{ $t('rubinred.content.builder.closeModal.message', primaryLocale) }}
            </div>
            <div class="rr-builder-dialog__footer rr-builder-dialog__footer_first-left uk-modal-footer uk-text-right">
                <button type="button" class="uk-button uk-button-text uk-modal-close">{{ $t('rubinred.content.builder.closeModal.back_editing', primaryLocale) }}</button>
                <button type="button" class="uk-button uk-button-danger" @click="view">{{ $t('rubinred.content.builder.closeModal.discard_changes', primaryLocale) }}</button>
                <button type="button" class="uk-button uk-button-primary" @click="save">{{ $t('rubinred.content.builder.closeModal.save_changes', primaryLocale) }}</button>
            </div>
        </div>
    </div>
</template>

<script>
  import PrimaryLocaleAwareComponent from "rubinred/content/js/mixins/PrimaryLocaleAwareComponent";

  export default {
    mixins: [PrimaryLocaleAwareComponent],
    data() {
      return {
        modal: null,
      }
    },
    created() {
      this.$root.$on('open-builder-close-modal', this.show);
      this.$root.$on('close-builder-close-modal', this.hide);
    },

    mounted() {
      this.modal = window.App.UIkit.modal(this.$el, {bgClose: false});
    },

    methods: {
      show() {
        this.modal.show();
      },
      hide() {
        this.modal.hide();
      },
      save() {
        this.$root.$emit('save-blocks-content');
        this.modal.hide();
      },
      view() {
        this.$root.$emit('view-mode');
        this.modal.hide();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/content/assets/js/components/BuilderCloseModal.vue